<template>
  <div class="success-transfer">
    <div class="messageTransfer">
      <div class="iconTransfer">
        <md-icon
          class="icon"
          md-src="/static/images/icon-transfer-sucess.svg"
        />
      </div>
      <div class="flex-5">
        <p>
          <span class="highlight highlight-green">{{ transferReports.samplesCount }}</span>
          <span v-if="transferReports.samplesCount > 1">Amostras geradas com <br>sucesso!</span>
          <span v-else>Amostra gerada com <br>sucesso!</span>
        </p>
      </div>
    </div>
    <div class="messageTransfer">
      <div class="iconTransfer">
        <md-icon
          md-src="/static/images/icon-transfer-sucess.svg"
          alt=""
        />
      </div>
      <div class="flex-5">
        <p>Nenhuma falha identificada no processo.</p>
      </div>
    </div>

    <div>
      <button
        v-if="patientLink && toggle.tagPrint"
        class="btn btn-primary button"
        @click="$router.push(patientLink)"
      >
        VER AMOSTRAS DO PACIENTE
      </button>
      <button
        v-else-if="toggle.tagPrint"
        class="btn btn-primary button"
        @click="pushToPrint()"
      >
        VISUALIZAR AMOSTRAS E LOTES
      </button>
      <br>
      <button
        class="btn btn-primary button"
        @click="redirectToDocRequiredPage()"
      >
        ANEXAR DOCUMENTOS OBRIGATÓRIOS
      </button>
      <br>
      <button
        class="btn btn-nonenary button"
        @click="pushToOrdersList()"
      >
        VOLTAR PARA LISTAGEM DE OS
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SuccessTransfer',
  props: {
    patientLink: String,
    transferReports: Object,
    pushToPrint: Function,
    pushToOrdersList: Function
  },
  computed: {
    ...mapGetters(['preference', 'toggle'])
  },
  methods: {
    redirectToDocRequiredPage() {
      this.$router.replace('/documentos-obrigatorios')
    }
  }
}
</script>

<style lang="scss">
.success-transfer {
  .md-icon {
    height: 41px;
    width: 41px;
  }

  .md-dialog-content {
    padding: 0 20px 34px;
  }

  .messageTransfer {
    display: flex;
    flex-direction: row;
  }
  .iconTransfer {
    flex: 1;
    padding-bottom: 10px;
  }

  p {
    text-align: start;
    padding: 1px 0 23px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    color: #617173;
    line-height: 19px;
    font-size: 15px;
    text-align: start;
    font-weight: 400;
    margin-left: 10px;
  }

  .md-dialog-content {
    padding: 0 34px 20px;
  }

  .highlight {
    font-weight: 900;

    &-green {
      color: #219653;
    }
  }

  .button {
    width: 100%;
    margin-top: 10px;
    font-family: Roboto, sans-serif;
    border-radius: 3px;
    font-weight: 500;
    letter-spacing: 0.4px;
  }

  .flex-5 {
    flex: 5;
  }
}
</style>
